import { getNestedProperty, getLocalizedValue } from '@grandvisionhq/utils';

function getDiscountDescription(prices, locale) {
    if (!Array.isArray(prices) || !prices.length) {
        return '';
    }
    const priceObject = prices[0];
    const description = getNestedProperty(priceObject, 'discounted.discount.obj.description');
    return getLocalizedValue(description, locale);
}

export { getDiscountDescription };
//# sourceMappingURL=get-discount-description.js.map
